// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3R3Gz","left":"InfoRow_left__3_lxd"};